import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// Store
import { PolicySelectors } from '@amfam/policy/data-access';
import { Policy } from '@amfam/policy/models';

import * as fromRoot from '../../core/store';

@Component({
  selector: 'risk-card',
  templateUrl: './risk-card.component.html',
  styleUrls: ['./risk-card.component.scss'],
  standalone: false
})
export class RiskCardComponent implements OnInit, OnDestroy {
  @Input() newCard: boolean = false;
  @Output() onPolicyChange = new EventEmitter<Policy>();
  private policy: Policy;
  private stop$: Subject<void> = new Subject<void>();

  private policySub$: Observable<Policy>;

  constructor(private store: Store<fromRoot.RootState>) {}

  ngOnInit() {
    this.policySub$ = this.store.select(PolicySelectors.selectSelectedPolicy);
    this.policySub$.pipe(takeUntil(this.stop$)).subscribe(policy => {
      this.policy = policy;
      this.onPolicyChange.emit(policy);
    });
  }

  ngOnDestroy() {
    this.stop$.next();
    this.stop$.complete();
  }
}
